import { Component, Optional, OnInit } from '@angular/core';
import { NbDialogRef, NbCardModule, NbButtonModule, NbInputModule, NbDialogService } from '@nebular/theme';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BasicDialogComponent } from '../basic-dialog/basic-dialog.component';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-import-report-code-dialog',
  templateUrl: './import-report-code-dialog.component.html',
  styleUrls: ['./import-report-code-dialog.component.scss'],
  standalone: true,
  imports: [
    NbCardModule,
    NbButtonModule,
    NbInputModule,
    FormsModule,
    TranslateModule,
    FontAwesomeModule
  ]
})
export class ImportReportCodeDialogComponent implements OnInit {
  public reportCode: string = '';

  constructor(
    @Optional() public ref: NbDialogRef<ImportReportCodeDialogComponent>,
    private translate: TranslateService,
    private dialogService: NbDialogService
  ) {}

  public ngOnInit(): void {
    this.initializeBackdropClick();
  }

  private initializeBackdropClick(): void {
    if (this.ref && (this.ref as any).onBackdropClick) {
      (this.ref as any).onBackdropClick.pipe(take(1)).subscribe(() => {
        this.cancel();
      });
    }
  }

  public import(): void {
    if (!this.reportCode || !this.reportCode.trim()) {
      return;
    }

    this.dialogService.open(BasicDialogComponent, {
      context: {
        title: this.translate.instant("site_control_reports.automatic_import"),
        content: this.translate.instant("site_control_reports.report_code_not_recognized"),
        canCancel: false
      }
    });
  }

  public cancel(): void {
    this.ref.close(null);
  }
}

